export default{
    __fullpage_hint: {
        landscape_title: 'Please rotate your screen',
        landscape_content: 'In order to ensure the best user experience, please rotate your screen to be portrait, thank you.',
        understood: 'understood',
    },
    __menu: {
        map: 'map',
        table: 'monitor',
        table_pub: 'obs',
        product: 'weather',
        background: 'overlays',
        setting: 'setting',
        language: '語言',
        account: 'account',
        about: 'about',
        previous: 'pre'
    },
    __acount: {
        account: 'Account'
    },
    __language_setting: {
        top_hint: 'Language Setting',
    },
    __footer: {
        about: 'ABOUT QPEplus',
        how: '【怎麼用】',
        switch_lang: '【中文】',
        offcial_web_link: 'Central Weather Adminiatration Copyright Reserved | Reference time: TST (Taiwan Standard Time; GMT + 08:00)',
        telephone: 'Tel: +886-2-2349-1000',
        address: 'Address: 64, Gongyuan Road, Taipei 100006, Taiwan (R.O.C.)'
    },
    __navbar: {
        alert_message: 'Warnings',
        logout: 'Log Out'
    },
    __map_obs: {
        is_loading: 'Loading...',
        top_hint: 'Select data',
        close_all_tree: 'Collapse all folders',
        cancel_all: 'Deselect All',
        show_pic_data: 'Display',
        no_check_any_option_alert: 'Please check at least one option！',
    },
    __background: {
        top_hint: 'Select data',
        cancel_all: 'Deselect All',
        update_background: 'Display'
    },
    __time_choose: {
        top_hint: 'Set time',
        node_name: 'Data Time',
        update: 'Send',
        select_bar_label: 'select time option',
        real_time: 'Real Time Data (Default)',
        customized_search: ' Customized Time Periods',
        start_date_label: 'Start Date',
        start_time_label: 'Start Time',
        end_time_label: 'End Time',
        display_interval_label: 'Time Period',
        back_to_date_select: 'Back',
        choose_time_warning: 'Select time exceeds current time',
        cancel: 'cancel',
        decide: 'ok',
    },
    __emap: {
        loading_text: 'Map Loading... Please Wait.',
        hide_legend_colorbar: 'Hide legends and colorbars',
    },
    __product_setting: {
        title: 'Set selected image data',
        draggable_tooltip_text: 'Drag up and down to adjust the layer order',
        opacity: 'Opacity',
        map_zoom: 'Map zoom',
        least: 'least',
        largest: 'largest',
        visible_information: 'Weathercock visible information',
        no_release: 'No release at this time',
        fix: 'Station maintenance',
        no_data: 'No data at this time',
        init_text: 'initiation',
        forecast_text: 'forecast ',
        no_data_and_no_release: 'No data and no release at this time'
    },
    __legend_color_bar_tool: {
        color_bar_hint: 'Click color block to show on /off',
        legend_text: 'legend',
        color_bar_text:  'colorbar',
    },
    __timeline: {
        rewind: 'Rewind',
        play :'Play',
        pause: 'Pause',
        fast_forward: 'Fast Forward'
    },
    __auto_update_panel: {
        tooltip: 'Auto Refresh',
    },
    __gis: {
        station: 'Stations',
        beaufort_scale: 'Beaufort scale',
        auto_gauge_station: 'Automatic Rain Gauge Stations',
        not_exceeding_heavy_rain: 'not exceeding heavy rain',
        heavy_rain: 'heavy rain',
        extremely_heavy_rain: 'extremely heavy rain',
        torrential_rain: 'torrential rain',
        extremely_torrential_rain: 'extremely torrential rain',
        watch_rainfall_diagram_text: "Hyetograph",
        watch_weather_diagram_text: "Weather Diagram",
        diagram: "Diagram",
    },
    __geojson: {
        typhoon_route: 'route',
        typhoon_time: 'time',
        typhoon_animation: 'animation',
        lightning: 'Lightning',
        CG_last_3_mins: 'CG Lightning Last 3 minutes',
        IC_last_3_mins: 'IC Lightning Last 3 minutes',
        CG_last_10_mins: 'CG Lightning Last 10 minutes',
        IC_last_10_mins: 'IC Lightning Last 10 minutes',
        CG_last_30_mins: 'CG Lightning Last 30 minutes',
        IC_last_30_mins: 'IC Lightning Last 30 minutes',
        typhoon_icon_text_severe:'Severe typhoon',
        typhoon_icon_text_moderate:'Moderate typhoon',
        typhoon_icon_text_mild:'Mild typhoon',
        typhoon_icon_text_TD:'Tropical depression'
    },
    __search_field: {
        label: 'Search keywords',
    },
    __datatable: {
        datatime: 'data time',
        no_data_text: 'no data',
        no_results_text: 'no search results',
        explanation: 'explanation',
        download_pdf_text: 'Download PDF',
        loading_text: 'Table Loading... Please Wait.',
        no_available_data_any_time_text: 'This table no available data',
        no_available_data_in_time_text: 'No available data in time.',
        backend_response_fail_text: 'Server response error, please contact system maintainer.',
        ajax_error_text: 'Unknown error, please contact system maintainer.',
        unknown_error_text: 'Loading time too long, please try again later; If it keeps happening, please contact system maintainer.',
        description_file_error_text: 'description file error, please contact system maintainer.',
        capture_text: 'loading',
        hint: 'hint'
    },
    __monitor: {
        top_hint: 'Select table',
        info: "information",
        no_data_annotaion: 'NB: "--" means no data.',
        min_10_gust_annotation: '⁺ 10 minutes maximum gust',
        hour_1_gust_annotation: '* 1 hour maximum gust',
    },
    __rainfall: {
        default_name: 'Rainfall Observations',
        rainfall: 'Rainfall',
        heavy_rain: 'heavy rain', 
        extremely_heavy_rain: 'extremely heavy rain', 
        torrential_rain: 'torrential rain',
        extremely_torrential_rain: 'extremely torrential rain',
        description_head: 'Color shading: ',
        description_tail: '',
        no_data_annotaion: 'NB: "--" means no data.',
        init_interval: '10-Minute',
        init_precp: 'Display All',
        display_all_city: 'All city',
        display_all_township: 'All township',
        city: 'County/City', 
        township: 'Township/City/District',
        min_10: '10-Minute',
        hour_1: '1-Hour',
        hour_3: '3-Hour',
        hour_6: '6-Hour',
        hour_12: '12-Hour',
        hour_24: '24-Hour',
        hour_48: '48-Hour',
        hour_72: '72-Hour',
    },
    __surface_weather: {
        default_name: 'Weather Observations',
        display_all_city: 'All_city',
        display_all_township: 'All township',
        city: 'County/City', 
        township: 'Township/City/District',
    },
    __timeseries: {
        x_axis_label: 'time',
        y_axis_label: 'rainfall (mm)',
        y_axis2_label: 'rainfall (mm)',
        accumlated_precp_timeseries_text: ' Hyetograph',
        time_select_text: 'Accumulated Precp Time',
        legend_accumlated_precp: 'Accmulated Rainfall',
    },
    __chart_common: {
        station_code_key: 'Station Code',
        day_select_text: 'Display Range',
        day_1: '1-Day',
        day_2: '2-Day',
        day_3: '3-Day',
        day_4: '4-Day',
        day_5: '5-Day',
        day_6: '6-Day',
        yaxis_max_select_text: 'Y-axis Max value',
        yaxis2_max_select_text: 'Y-axis2 Max value',
        reset_time_range: 'Reset Time Range',
        save_image: 'Save Image',
        tooltip_value: 'data value',
        tooltip_time: 'data time',
        legend_no_data: 'No Data',
        no_data: 'no data',
        back_to_gis_popup_table: 'back to station information',
        loading_text: 'Chart Loading... Please Wait.',
        error_text: {
            station_code: 'Not found station, please attempt later.',
            default: 'Fail loading chart, please attempt later.',
        }
    },
    __monitor_weather: {
        wind_direction: 'Wind Direction',
        wind_speed: 'Wind Speed',
        temperature: 'Temperature',
        humidity: 'Relative Humidity',
        pressure: 'Pressure',
        x_axis_label: 'time',
        wind_direction_text: 'Wind Direction(°)',
        wind_speed_text: 'Wind Speed(m/s)',
        temperature_text: 'Temperature(°C)',
        humidity_text: 'Relative Humidity(％)',
        pressure_text: 'Pressure(hPa)',
        timing_diagram_text: ' Diagram',
        legend_max: 'Max ',
        legend_min: 'Min ',
        legend_gust: 'Gust',
        legend_wind_speed_text: ' Speed',
        legend_time_text: ' Time',
        wind_level: 'level',
        weather_variable: 'weather variable',
        gust_time: 'gust time',
        gust_value: 'gust value',
        min_10: '10-Minute',
        hour_1: '1-Hour ',
    },
    __caputre: {
        datetime_description: 'data time' 
    },
    __notification: {
        notification_btn_tooltip_text: 'Show notification and announcement',
        severe_weather_advisories: 'Severe Weather Advisories',
        announcements: 'Announcements'
    },
    __toggle_menu_btn: {
        hint_text: 'open/close menu'
    },
    __favorites: {
        hint_text: 'Set favorites',
        delete_text: 'Delete',
        update_text: 'Update'
    }
}